import apiClient from '../apiClient';
import { GET_LIST_TRANSPORTATION_UNIT_BY_PROFILE_ID_URL } from '../apiUrl';

const getTransportationUnitByProfileIdApi = Id => {
  return apiClient.get(GET_LIST_TRANSPORTATION_UNIT_BY_PROFILE_ID_URL(Id));
};

export default getTransportationUnitByProfileIdApi;
